// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 28) return "static/js/b52206148ef63e2631a1.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"23f0988cfaa23883a0fd","150":"d148aa430367427ae7cb","151":"5e6496e439276c14dd33"}[chunkId] + ".chunk.js";
};